import { createRouter, createWebHistory, RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { isMobile } from '../utils/tool';


// 定义路由配置
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: () => import('../components/layouts/AppLayout.vue'),
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('../views/HomeView.vue'),
                meta: {
                    title: '首页'
                }
            },
            {
                path: '/about',
                name: 'About',
                component: () => import('../views/AboutView.vue'),
                meta: {
                    title: '关于我们'
                }
            },
            {
                path: '/process',
                name: 'Process',
                component: () => import('../views/ProcessView.vue'),
                meta: {
                    title: '合作流程'
                }
            },
            {
                path: '/news',
                name: 'News',
                component: () => import('../views/NewsView.vue'),
                meta: {
                    title: '品牌资讯'
                }
            },
            {
                path: '/news/:id',
                name: 'NewsDetail',
                component: () => import('../views/NewsDetail.vue'),
                meta: {
                    title: '资讯详情'
                }
            },
            {
                path: '/contact',
                name: 'Contact',
                component: () => import('../views/ContactView.vue'),
                meta: {
                    title: '联系我们'
                }
            }
        ]
    }
];

// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes
});

// 全局前置守卫 - 用于设置页面标题和移动端重定向
router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    // 设置页面标题
    document.title = to.meta.title as string ? to.meta.title as string + ' - 雀星汇24小时自助棋牌 | 浙江雀星汇品牌管理有限公司官网' : '雀星汇24小时自助棋牌 | 浙江雀星汇品牌管理有限公司官网';

    // 移动端判断 - 如果是移动端且不在Home路由时，重定向到首页
    if (isMobile() && to.name !== 'Home') {
        next({ name: 'Home' });
    } else {
        next();
    }
});

// 全局后置守卫 - 可以用于统计、日志等
router.afterEach((to: RouteLocationNormalized, _from: RouteLocationNormalized) => {
    // 这里可以添加日志记录、性能监控等功能
    console.log(`导航到 ${to.path}`);
});

export default router;